import {useDebugValue} from 'react';

import {
    useCookies,
    useSystem,
    useMedia,
    useEdap,
    useSearch,
    useForm,
    useDestination,
    useDates,
    useGuests,
    useSubmit
} from './';

function useSearchFormContext(props) {
    const cookies = useCookies();

    const system = useSystem(props);
    const media = useMedia(props);

    const edap = useEdap(props);

    const search = useSearch(props);

    const form = useForm(props);

    const destination = useDestination(props, cookies, system);
    const dates = useDates(props, cookies, system);
    const guests = useGuests(props, cookies, system);

    const submit = useSubmit(props);

    const result = {
        system,
        media,
        edap,
        search,
        form,
        destination,
        dates,
        guests,
        submit
    };

    useDebugValue(result);

    return result;
}

export {useSearchFormContext};
